import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import FormulaForm from './FormulaForm'
import FormulaCard from './FormulaCard'

import Resource from '../../stores/resource'
const FormulaStore = Resource('formulas')

class NewFormula extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      formula: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    // Deleting illegal attributes
    delete attributes.type
    FormulaStore.create(attributes)
    .then((result) => {
      this.setState({
        saved: true,
        error: '',
        savedFormula: result.data.data,
        snackbarMessage: `Formula "${attributes.name}" created!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedFormula)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/formulas`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const formula = this.state.formula
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <FormulaForm
          formTitle={this.props.formTitle}
          name={formula.name}
          formula={formula.formula}
          formulaType={formula.formulaType}
          notes={formula.notes}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />
        <br/>

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create formula">
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(this.state.saved)}
            title="Formula created">
            <p>
              A new formula has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <FormulaCard
              formula={this.state.savedFormula}
              editCallback={() => this._redirectTo(`/formulas/${this.state.savedFormula.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewFormula



// WEBPACK FOOTER //
// ./src/components/Formulas/NewFormula.jsx